module.exports = __webpack_public_path__ + "45a5b2e516a003b0dc1ab6d12a76eba2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Watkinson.png
// module id = /WxB
// module chunks = 0